import { Box } from '@chakra-ui/react'

import { BrandColor } from 'src/types'

import CardWrapper from '../../CardWrapper/CardWrapper'
import ExpandableText from 'src/components/widgets/ExpandableText/ExpandableText'

export type TextCardProps = {
  heading?: string
  description?: string
  brandColor: BrandColor
  isFirstItem: boolean
  itemId: number
}

const TextCard: React.FC<TextCardProps> = ({
  isFirstItem,
  brandColor,
  heading,
  description,
  itemId,
}) => {
  description = description || (heading ? '' : 'Text section...')

  return (
    <CardWrapper
      mb={heading ? 6 : 10}
      boxShadow="none"
      itemId={itemId}
      brandColor={brandColor}
    >
      <Box
        w="48px"
        h="4px"
        borderRadius={2}
        bg={brandColor}
        mb={2}
        mt={isFirstItem ? 6 : 10}
      />
      {!!heading && (
        <Box as="h4" className="thick" data-testid="textCard-title">
          {heading}
        </Box>
      )}
      {!!description && (
        <ExpandableText
          mt={2}
          data-testid="textCard-description"
          className="body-small"
          color="stone"
          collapseThreshold={1000}
          text={description}
          expandCollapseButtonProps={{
            textColor: brandColor,
            labelExpanded: 'Less',
            labelCollapsed: 'More',
          }}
        />
      )}
    </CardWrapper>
  )
}

export default TextCard
